/* eslint-disable radix */
import axios from "axios";

export const isDataStale = () => {
  const ttl = localStorage.getItem("iconsDataCache");
  if (ttl === null || ttl === undefined) return true;
  return Date.now() >= parseInt(ttl);
};

export const store = data => {
  const ttl = new Date();
  localStorage.setItem("iconsData", JSON.stringify(data));
  localStorage.setItem("iconsDataCache", ttl.setDate(ttl.getDate() + 1));
};

export const retrieve = () => {
  const data = localStorage.getItem("iconsData");
  if (data) {
    return JSON.parse(data);
  }
  return null;
};

export const chunk = (array, size) => {
  const chunked = [];
  for (let i = 0; i < array.length; i += 1) {
    const last = chunked[chunked.length - 1];
    if (!last || last.length === size) {
      chunked.push([array[i]]);
    } else {
      last.push(array[i]);
    }
  }
  return chunked;
};

export const getIcons = () => {
  return new Promise((resolve, reject) => {
    if (isDataStale()) {
      const t = new Date();
      axios
        .get(
          `https://storage.alboompro.com/static/prosite/icons/icons.json?t=${t}`
        )
        .then(({ data }) => {
          store(data);
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    } else {
      resolve(retrieve());
    }
  });
};
